// metodos para consultas de status  

export default {  
	access_display(state){ return state.display; },
	lateral(state){ return state.lateralShow; },
	get_displayEdit(state){ return state.displayEdit;},  
    getAppIDactual(state) {return state.appIDactual},
    loggedIn(state) {
      //console.log('loggedIn valor del token = ', state.token);
      return state.token !== null
    },
    getShowAside(state) {
      return state.showAside
    },
    specialItemCurrent(state) {
      return state.SpecialsItemActive
    },
    privilegiesSesion(state) {
      return state.privilegies;
    },
    modulos(state) {
      return state.modulos;
    },
    orginf(state){
      return state.infoorg
    },
    getListOrgs(state){
      return state.orgAll;
    },
    applistorgs(state){
      return state.appAll
    },
    access_account(state){
      return state.account;
    },
    newfoodAction(state){
      return state.newFoodAction;
    },
    access_Dimenu(state){
      return state.dimenu;
    },
    get_menutab(state){return state.menutab; },
    get_menuCatActive(state){return state.menuCatActive; },
    get_retornoAside(state){return state.retornoAside; },
    dataAsideMenu(state){return state.dataAsideMenu;},
    imageActiveFood(state){return state.imageActiveFood},
    getActionSpecials(state){return state.actionUpdate},
    getSpecialsAll(state){
      return state.SpecialsLists
    },
    get_groupActive(state){return state.groupActive},
    get_groupList(state){return state.groupList},
    get_listCategores(state){return state.listCategores},
    get_reserve(state){return state.reserve},
    get_urlWebDimenu(state){return state.urlWebDimenu},
    get_accitonPusher(state){ return state.accitonPusher;},
    getCropperImagenes(state){ return state.cropperImagenes;},
    getOpenModal(state){ return state.getOpenModal;},
    getLoadingModal(state) { return state.loadingModal;},
    getvariantData(state) { return state.variantData;},
    getvariantFoodData(state) { return state.variantFoodData;},
    getnewFoodCat(state) { return state.newFoodCat;},
}
